import { useMutation } from '@tanstack/react-query';
import { widgetShopApi } from '@entities/widget-shop/api';
import { reloadPage } from '@shared/helpers';

export const useEnableWidgetTrialPeriod = () => {
    return useMutation({
        mutationFn: widgetShopApi.enableWidgetTrialPeriod,
        onSuccess: () => {
            reloadPage();
        },
    });
};
